import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';

import { getEdition } from '@jira/platform__application-editions/src/edition.tsx';
import { getApplicationForProject } from '@jira/platform__application-editions/src/application.tsx';
import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import type { Action } from '@atlassian/jira-experience-tracker/src/common/constants.tsx';

// Issue Transition SLA
export const transitionIssueExperienceDescription = (
	wasSuccessful: boolean,
	method: 'GET' | 'POST',
	analyticsSource: string,
	projectType: ProjectType | null,
	errorMessage?: string,
	traceId?: string | undefined,
	statusCode?: number | undefined,
	action?: Action,
) => {
	let application = null;
	let edition = null;

	if (projectType !== null) {
		try {
			const { appEditions } = getTenantContext_DEPRECATED_DO_NOT_USE();
			application = getApplicationForProject(projectType);
			edition = getEdition(application, appEditions);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			// application and edition already default to null.
		}
	}

	// Flow sadly cannot do multiple spreads in one object, and additionalAttributes
	// cannot potentially contain fields as undefined.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const additionalAttributes: Record<string, any> = {};

	if (errorMessage != null) {
		additionalAttributes.errorMessage = errorMessage;
	}

	if (traceId != null) {
		additionalAttributes.traceId = traceId;
	}

	if (statusCode) {
		additionalAttributes.statusCode = statusCode;
	}

	const experience = method === 'POST' ? 'transitionIssue' : 'getTransitions';

	return {
		experience,
		action,
		wasExperienceSuccesful: wasSuccessful,
		analyticsSource,
		application,
		edition,
		additionalAttributes: {
			...additionalAttributes,
			method,
		},
	};
};
